import { ProjectShellRoute } from "@/components/ProjectShell";

export function ProjectLayout() {
  return <ProjectShellRoute />;
}
